
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aGjYc", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");

const $9a76668fa978df44$export$6af3d18059afaa9e = 'outOfDate';
const $9a76668fa978df44$export$926918591069cc4f = ()=>(0, $6mKj3.expValEquals)('confluence_fe_create_comment_optimistic', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_fe_reply_comment_optimistic', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_fe_edit_comment_optimistic', 'isEnabled', true);
const $9a76668fa978df44$export$af7cdd47474fbc83 = (// TODO: (COMMENTS-6792) `type` is no longer needed. Remove this later.
_type, mode)=>{
    if (!$9a76668fa978df44$export$926918591069cc4f()) return false;
    switch(mode){
        case 'create':
            return (0, $6mKj3.expValEquals)('confluence_fe_create_comment_optimistic', 'isEnabled', true);
        case 'reply':
            return (0, $6mKj3.expValEquals)('confluence_fe_reply_comment_optimistic', 'isEnabled', true);
        case 'edit':
        default:
            return (0, $6mKj3.expValEquals)('confluence_fe_edit_comment_optimistic', 'isEnabled', true);
    }
};
const $9a76668fa978df44$var$logger = (0, $7W8i8.getLogger)('comment-draft-utils');
const $9a76668fa978df44$export$a47fb462a08de82f = (type, mode)=>{
    if ($9a76668fa978df44$export$926918591069cc4f()) switch(type){
        // Treat edit-inline and inline as the same type, so a comment draft
        // saved in EDITOR mode can be used in VIEW mode of the same page.
        case 'edit-inline':
        case 'inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_REPLY;
        case 'page':
        default:
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_REPLY;
    }
    // TODO: (COMMENTS-6792) Remove this when optimistic save is rolled out
    switch(type){
        case 'edit-inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_REPLY;
        case 'inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_REPLY;
        case 'page':
        default:
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_REPLY;
    }
};
const $9a76668fa978df44$export$a4f0a5ceed96eae8 = (adf, pageId, type, mode)=>{
    let b64EncodedDraftObj = null;
    const key = $9a76668fa978df44$export$a47fb462a08de82f(type, mode);
    const draftObj = JSON.stringify({
        pageId: pageId,
        adf: adf
    });
    try {
        if ($9a76668fa978df44$export$926918591069cc4f()) b64EncodedDraftObj = $9a76668fa978df44$export$708cfc4e2abfde1e(draftObj);
        else b64EncodedDraftObj = btoa(draftObj);
    } catch (e) {
        $9a76668fa978df44$var$logger.error`Unable to save draft object for ${pageId}; ${e}`;
    }
    if (b64EncodedDraftObj === null) return false;
    // Store the draft with a 72 hour expiration
    (0, $17wUi.confluenceLocalStorageInstance).setItem(key, b64EncodedDraftObj, 259200);
    return true;
};
const $9a76668fa978df44$export$e7cfba777a0d590e = (type, mode)=>{
    const key = $9a76668fa978df44$export$a47fb462a08de82f(type, mode);
    (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
};
const $9a76668fa978df44$export$5fff31d3d3e1ad8b = (pageId, type, mode)=>Boolean($9a76668fa978df44$export$7c0604f3bd51258a(pageId, type, mode));
const $9a76668fa978df44$export$7c0604f3bd51258a = (pageId, type, mode)=>{
    let draftObj = null;
    const key = $9a76668fa978df44$export$a47fb462a08de82f(type, mode);
    const b64EncodedDraftObj = (0, $17wUi.confluenceLocalStorageInstance).getItem(key);
    if (b64EncodedDraftObj !== null) {
        try {
            if ($9a76668fa978df44$export$926918591069cc4f()) draftObj = JSON.parse($9a76668fa978df44$export$5590361fa8c7b71(b64EncodedDraftObj));
            else draftObj = JSON.parse(atob(b64EncodedDraftObj));
        } catch (e) {
            $9a76668fa978df44$var$logger.error`Unable to get draft object for ${pageId}; ${e}`;
        }
        if (draftObj) {
            const { pageId: draftPageId, adf: adf } = draftObj;
            // If the pageId matches, return the ADF, otherwise return null
            if (draftPageId === pageId) return adf;
        }
    }
    return null;
};
const $9a76668fa978df44$export$708cfc4e2abfde1e = (adfString)=>{
    const bytes = new TextEncoder().encode(adfString);
    let binary = '';
    for(let i = 0; i < bytes.byteLength; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
};
const $9a76668fa978df44$export$5590361fa8c7b71 = (base64)=>{
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return new TextDecoder().decode(bytes);
};
module.exports["OUT_OF_DATE_KEY"] = $9a76668fa978df44$export$6af3d18059afaa9e;
module.exports["isOptimisticSaveEnabled"] = $9a76668fa978df44$export$926918591069cc4f;
module.exports["shouldUseCommentDraftForOptimisticSave"] = $9a76668fa978df44$export$af7cdd47474fbc83;
module.exports["saveCommentDraft"] = $9a76668fa978df44$export$a4f0a5ceed96eae8;
module.exports["clearCommentDraft"] = $9a76668fa978df44$export$e7cfba777a0d590e;
module.exports["hasCommentDraft"] = $9a76668fa978df44$export$5fff31d3d3e1ad8b;
module.exports["getCommentDraft"] = $9a76668fa978df44$export$7c0604f3bd51258a;

});

parcelRegister("emtVP", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $130CJ = parcelRequire("130CJ");


var $as9lu = parcelRequire("as9lu");


var $6mKj3 = parcelRequire("6mKj3");


var $f7B1p = parcelRequire("f7B1p");


var $3UYxt = parcelRequire("3UYxt");


var $gXKuh = parcelRequire("gXKuh");


var $4ywyi = parcelRequire("4ywyi");


var $9hI9O = parcelRequire("9hI9O");


var $henaO = parcelRequire("henaO");

const $01f4748f04f8193a$var$MAX_TRACKED_COMMENT_INVOCATIONS = 500;
// Deduplicate repeated save callbacks for a comment within this page lifetime. This bounded,
// in-memory set is not persisted session state or a guarantee across reloads.
const $01f4748f04f8193a$var$invokedCommentIds = new Set();
function $01f4748f04f8193a$var$claimCommentInvocation(commentId) {
    if (!commentId) return true;
    if ($01f4748f04f8193a$var$invokedCommentIds.has(commentId)) return false;
    if ($01f4748f04f8193a$var$invokedCommentIds.size >= $01f4748f04f8193a$var$MAX_TRACKED_COMMENT_INVOCATIONS) {
        const oldestCommentId = $01f4748f04f8193a$var$invokedCommentIds.values().next().value;
        if (oldestCommentId) $01f4748f04f8193a$var$invokedCommentIds.delete(oldestCommentId);
    }
    $01f4748f04f8193a$var$invokedCommentIds.add(commentId);
    return true;
}
function $01f4748f04f8193a$export$136e502d40ccc0cf() {
    $01f4748f04f8193a$var$invokedCommentIds.clear();
}
function $01f4748f04f8193a$export$c0ee55695026b723(adf) {
    if (!adf?.content) return false;
    const stack = [
        adf
    ];
    while(stack.length > 0){
        const node = stack.pop();
        if (!node) break;
        if (node.type === 'mention' && node.attrs?.userType === 'APP' && typeof node.attrs?.id === 'string' && node.attrs.id !== '') return true;
        if (Array.isArray(node.content)) {
            // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- ADF trees are shallow (typically <10 levels); linear in total node count
            for (const child of node.content)if (child) stack.push(child);
        }
    }
    return false;
}
/**
 * Builds an `AgentMentionInfo` from a mention node and its position within the
 * parent's content. Returns null when the node has no usable id.
 */ function $01f4748f04f8193a$var$buildMentionInfo(node, siblings, index, adf) {
    if (!node.attrs?.id) return null;
    const agentId = node.attrs.id;
    const rawMentionText = node.attrs.text ?? '';
    const agentName = rawMentionText.replace(/^@/, '');
    // Preserve the original single-paragraph prompt while the inline comment
    // experience is off.
    const paragraphPrompt = siblings.map((sibling, j)=>{
        if (j === index) return rawMentionText;
        return sibling?.type === 'text' && sibling.text ? sibling.text : '';
    }).join('').trim() || rawMentionText;
    const promptText = (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) ? $01f4748f04f8193a$var$serializeAdfText(adf).trim() || rawMentionText : paragraphPrompt;
    return {
        agentId: agentId,
        agentName: agentName,
        promptText: promptText
    };
}
function $01f4748f04f8193a$var$serializeAdfText(adf) {
    const parts = [];
    const appendBlockBoundary = ()=>{
        if (parts.length > 0 && !parts[parts.length - 1].endsWith('\n')) parts.push('\n');
    };
    (0, $jTt8P.traverse)(adf, {
        paragraph: appendBlockBoundary,
        heading: appendBlockBoundary,
        codeBlock: appendBlockBoundary,
        text: (node)=>{
            parts.push(node.text ?? '');
        },
        mention: (node)=>{
            parts.push(node.attrs?.text ?? '');
        },
        hardBreak: ()=>{
            parts.push('\n');
        }
    });
    return parts.join('');
}
function $01f4748f04f8193a$export$c2a308e988ef7ce4(adf) {
    if (!adf?.content) return null;
    let result = null;
    // traverse walks the full tree even after we find a match — the early-return
    // guard below skips processing but doesn't stop traversal. This is acceptable
    // for comment ADF which is typically small (a few paragraphs).
    (0, $jTt8P.traverse)(adf, {
        mention: (node, parent, index)=>{
            if (result) return; // already found one
            if (node.attrs?.userType !== 'APP') return;
            result = $01f4748f04f8193a$var$buildMentionInfo(node, parent.node?.content ?? [], index, adf);
        }
    });
    return result;
}
function $01f4748f04f8193a$export$82632c733f1d4e2b(adf) {
    if (!adf?.content) return [];
    const candidates = [];
    (0, $jTt8P.traverse)(adf, {
        mention: (node, parent, index)=>{
            const info = $01f4748f04f8193a$var$buildMentionInfo(node, parent.node?.content ?? [], index, adf);
            if (info) candidates.push(info);
        }
    });
    return candidates;
}
function $01f4748f04f8193a$export$39e3aee0c3a40960(adf) {
    if (!adf?.content) return [];
    const ids = [];
    (0, $jTt8P.traverse)(adf, {
        mention: (node)=>{
            const id = node.attrs?.id;
            if (typeof id === 'string' && id !== '' && !node.attrs?.userType) ids.push(id);
        }
    });
    return ids;
}
/**
 * Resolves an Atlassian account ID (from the mention node) to an Agent Studio
 * UUID (needed by the CwR sidebar for agent pre-selection).
 *
 * Uses the Rovo assistance API with the same pattern as AssistanceServiceImpl.
 * Returns null when the account is not an agent (the endpoint yields an error
 * body with no `id`) or on any error — so callers can also use this as an
 * "is this mention an agent?" check. Agent pre-selection degrades gracefully.
 */ async function $01f4748f04f8193a$var$resolveAgentStudioId(accountId, cloudId, signal) {
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/assist/rovo/v1/agents/accountid/${$01f4748f04f8193a$var$normalizeIdentityAccountId(accountId)}`, {
            method: 'GET',
            headers: {
                'x-product': 'confluence',
                'x-experience-id': 'ai-mate',
                'x-cloudid': cloudId
            },
            signal: signal
        });
        const agent = await response.json();
        // A non-agent account id yields an error body with no `id`. Returning null
        // here lets callers treat this function as an "is this an agent?" check.
        if (!agent?.id) return null;
        return {
            id: agent.id,
            namedId: agent.named_id,
            name: agent.name,
            externalConfigReference: agent.external_config_reference
        };
    } catch (err) {
        return null;
    }
}
async function $01f4748f04f8193a$export$b035cc8717289977(accountId, cloudId, signal) {
    const resolved = await $01f4748f04f8193a$var$resolveAgentStudioId(accountId, cloudId, signal);
    return resolved ? {
        id: accountId,
        name: resolved.name,
        agentNamedId: resolved.externalConfigReference ?? resolved.namedId
    } : null;
}
function $01f4748f04f8193a$var$normalizeIdentityAccountId(accountId) {
    try {
        return (0, $as9lu.IdentityUserAri).parse(accountId).userId;
    } catch  {
        return accountId;
    }
}
async function $01f4748f04f8193a$var$setAgentSessionsProperty(pageId, userId) {
    const propertyKey = `cc-agent-mention-sessions:${userId}`;
    try {
        await (0, $f7B1p.cfetch)(`/wiki/api/v2/pages/${pageId}/properties`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                key: propertyKey,
                value: true
            })
        });
    } catch  {
    // Best-effort write — 409 means already set; any other error is non-fatal.
    }
}
/**
 * Resolves the given mention candidates against the Rovo agents endpoint and
 * returns the first one that is a real agent, together with its Studio id.
 * Returns null when none of the mentions resolve to an agent.
 *
 * Candidates are resolved sequentially so we short-circuit on the first agent
 * (comments typically contain a single mention).
 */ async function $01f4748f04f8193a$var$detectAgentMention(candidates, cloudId) {
    for (const mention of candidates){
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), (0, $gXKuh.AGENT_RESOLVE_TIMEOUT_MS));
        const resolved = await $01f4748f04f8193a$var$resolveAgentStudioId(mention.agentId, cloudId, controller.signal);
        clearTimeout(timeoutId);
        if (resolved?.id) return {
            mention: mention,
            studioId: resolved.id
        };
    }
    return null;
}
/**
 * Opens the CwR sidebar for an agent mention and fires the `chat-new` postMessage
 * (with page/comment conversation tags). When `preResolvedStudioId` is provided
 * (detected via id-resolution) it is used directly; otherwise the agent's Studio
 * id is resolved best-effort (with timeout) before sending.
 */ function $01f4748f04f8193a$var$openSidebarAndChat(agentMention, cloudId, pageId, commentId, userId, commentType, preResolvedStudioId, createAnalyticsEvent) {
    if ((0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) {
        // Claim before dispatch: two save callbacks would send distinct bridge commands.
        // Having a single command receiver does not deduplicate separate invocations.
        if (!$01f4748f04f8193a$var$claimCommentInvocation(commentId)) return;
        $01f4748f04f8193a$var$dispatchSidebarAndChat(agentMention, cloudId, pageId, commentId, userId, commentType, preResolvedStudioId, true, createAnalyticsEvent);
        return;
    }
    $01f4748f04f8193a$var$dispatchSidebarAndChat(agentMention, cloudId, pageId, commentId, userId, commentType, preResolvedStudioId, false, createAnalyticsEvent);
}
function $01f4748f04f8193a$var$dispatchSidebarAndChat(agentMention, cloudId, pageId, commentId, userId, commentType, preResolvedStudioId, runHeadlessly, createAnalyticsEvent) {
    if (userId && pageId) $01f4748f04f8193a$var$setAgentSessionsProperty(pageId, userId);
    if (runHeadlessly) (0, $4ywyi.startOptimisticCommentAgentSession)(commentId, {
        agentId: agentMention.agentId,
        agentName: agentMention.agentName
    });
    // 1. Notify the sidebar and session-discovery consumers. The rollout treatment keeps the
    // sidebar closed; the existing listener still owns the visible-chat control path.
    window.dispatchEvent(new CustomEvent((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), {
        detail: {
            ...agentMention,
            commentId: commentId,
            openSidebar: !runHeadlessly
        }
    }));
    if (commentType === 'inline' && cloudId && pageId && createAnalyticsEvent && (0, $6mKj3.expValEquals)('trigger_agentic_view_on_inline_comment_mention', 'isEnabled', true)) (0, $3UYxt.recordAgenticView)({
        contentId: pageId,
        pageContext: 'confluence-page-view',
        agentIdentityAccountId: $01f4748f04f8193a$var$normalizeIdentityAccountId(agentMention.agentId)
    }, cloudId, createAnalyticsEvent, {
        trigger: 'inlineCommentMention'
    });
    // 2. Resolve the agent, then hand off to the background command or the visible Chat path.
    const prompt = agentMention.promptText;
    const chatSourceId = `agent-mention-${agentMention.agentId}-${Date.now()}`;
    // Build the comment-mention conversation tags so the backend can create a
    // SessionAssociationPublic record (linking this conversation to the page/comment)
    // and initialize the WORKING state. ARI-formatted IDs are used so the values
    // persisted to ERS are valid Teamwork Graph ARI references, as required by
    // conversational-ai-platform PRs 31101 and 31525. The BE extracts the ARI via
    // substringAfter("page:") / substringAfter("comment:") and stores it as
    // entityId / subEntityId on SessionAssociationPublic.
    const pageAri = pageId && cloudId ? `ari:cloud:confluence:${cloudId}:page/${pageId}` : '';
    const commentAri = commentId && cloudId ? `ari:cloud:confluence:${cloudId}:comment/${commentId}` : '';
    const tags = pageAri && commentAri ? [
        'mention-in-comment',
        `page:${pageAri}`,
        `comment:${commentAri}`,
        ...(0, $6mKj3.expValEquals)('cc_ai_agent_mention_comment_type', 'isEnabled', true) ? [
            `comment-type:${commentType}`
        ] : []
    ] : undefined;
    const chatName = prompt.length > 30 ? `${prompt.substring(0, 30).trimEnd()}\u{2026}` : prompt;
    const sendChatNew = (resolvedAgentId)=>{
        const payload = {
            type: 'chat-new',
            source: 'agentMentionComment',
            ...runHeadlessly ? {
                openChat: true,
                consumeOnce: true
            } : {},
            data: {
                ...resolvedAgentId ? {
                    agentId: resolvedAgentId
                } : {},
                sourceId: chatSourceId,
                name: chatName,
                prompt: prompt,
                dialogues: [],
                mode: {
                    useCurrentPageContext: true
                },
                ...tags ? {
                    tags: tags
                } : {}
            }
        };
        window.postMessage({
            eventType: (0, $130CJ.ROVO_POST_MESSAGE_EVENT_TYPE),
            payload: payload,
            payloadId: crypto.randomUUID()
        }, window.location.origin);
    };
    const invokeAgent = async (resolvedAgentId)=>{
        if (runHeadlessly && resolvedAgentId && commentId && tags) {
            const sourceId = (0, $henaO.registerBackgroundConversationSource)(commentId);
            try {
                const accepted = await (0, $9hI9O.sendBackgroundAgentInvocation)({
                    agentId: resolvedAgentId,
                    source: 'agentMentionComment',
                    prompt: prompt,
                    name: chatName,
                    sourceId: sourceId,
                    tags: tags
                });
                if (accepted) return;
            } catch  {
                (0, $4ywyi.clearOptimisticCommentAgentSession)(commentId);
                // Delivery may already have started execution. Open Chat, but do not resend.
                window.dispatchEvent(new CustomEvent((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), {
                    detail: {
                        ...agentMention,
                        commentId: commentId,
                        openSidebar: true
                    }
                }));
                return;
            }
        }
        if (runHeadlessly) {
            (0, $4ywyi.clearOptimisticCommentAgentSession)(commentId);
            window.dispatchEvent(new CustomEvent((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), {
                detail: {
                    ...agentMention,
                    commentId: commentId,
                    openSidebar: true
                }
            }));
        }
        sendChatNew(resolvedAgentId);
    };
    // Studio id already known (detected via id-resolution) or cloudId missing
    // (cannot resolve) — send immediately.
    if (preResolvedStudioId || !cloudId) {
        invokeAgent(preResolvedStudioId);
        return;
    }
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), (0, $gXKuh.AGENT_RESOLVE_TIMEOUT_MS));
    $01f4748f04f8193a$var$resolveAgentStudioId(agentMention.agentId, cloudId, controller.signal).then((resolved)=>{
        clearTimeout(timeoutId);
        invokeAgent(resolved?.id ?? null);
    });
}
function $01f4748f04f8193a$export$bb4bebb0ee10d371(adf, cloudId, pageId, commentId, userId, commentType, createAnalyticsEvent) {
    // Fast path — a live comment still has userType='APP' on the agent mention.
    const fastPathMention = $01f4748f04f8193a$export$c2a308e988ef7ce4(adf);
    if (fastPathMention) {
        $01f4748f04f8193a$var$openSidebarAndChat(fastPathMention, cloudId, pageId, commentId, userId, commentType, null, createAnalyticsEvent);
        return;
    }
    // Fallback — persisted/copy-pasted comment: userType has been stripped, so
    // identify the agent by resolving the surviving mention id(s). Requires a
    // cloudId to call the agents endpoint.
    if (!cloudId) return;
    const candidates = $01f4748f04f8193a$export$82632c733f1d4e2b(adf);
    if (candidates.length === 0) return;
    $01f4748f04f8193a$var$detectAgentMention(candidates, cloudId).then((match)=>{
        if (!match) return; // none of the mentions are agents
        $01f4748f04f8193a$var$openSidebarAndChat(match.mention, cloudId, pageId, commentId, userId, commentType, match.studioId, createAnalyticsEvent);
    });
}
function $01f4748f04f8193a$export$7f191012969a4a56(conversationId) {
    if (!conversationId) return;
    const payload = {
        type: 'chat-open',
        source: 'agentMentionComment',
        data: {
            channelId: conversationId
        }
    };
    window.postMessage({
        eventType: (0, $130CJ.ROVO_POST_MESSAGE_EVENT_TYPE),
        payload: payload,
        payloadId: crypto.randomUUID()
    }, window.location.origin);
}
module.exports["hasAgentMention"] = $01f4748f04f8193a$export$c0ee55695026b723;
module.exports["extractAgentMentionFromAdf"] = $01f4748f04f8193a$export$c2a308e988ef7ce4;
module.exports["extractUnresolvedMentionIds"] = $01f4748f04f8193a$export$39e3aee0c3a40960;
module.exports["resolveAgentFromMentionId"] = $01f4748f04f8193a$export$b035cc8717289977;
module.exports["handleAgentMentionInComment"] = $01f4748f04f8193a$export$bb4bebb0ee10d371;
module.exports["reopenCommentAgentChat"] = $01f4748f04f8193a$export$7f191012969a4a56;

});

parcelRegister("gXKuh", function(module, exports) {
/**
 * Event dispatched when a comment containing an agent @mention is saved.
 * Listened to by useAgentMentionSidebarListener to open the CwR sidebar.
 */ const $b6c892aa1734c634$export$ca63cd40e8540dc2 = 'confluence:agent-mention-comment-saved';
const $b6c892aa1734c634$export$b5bdcb45f62962d2 = 'confluence:background-conversation-actions-reconcile';
const $b6c892aa1734c634$export$a31756fd55ed0e4f = 5000;
const $b6c892aa1734c634$export$a1f1ec50f461f04d = new Set([
    'whiteboard',
    'database'
]);
function $b6c892aa1734c634$export$29ca81875e26608b(contentType) {
    if (!contentType) return false;
    return !$b6c892aa1734c634$export$a1f1ec50f461f04d.has(contentType);
}
const $b6c892aa1734c634$export$69d55d1f6faf40c9 = 'confluence:agent-session-subscription-failed';
module.exports["AGENT_MENTION_COMMENT_SAVED_EVENT"] = $b6c892aa1734c634$export$ca63cd40e8540dc2;
module.exports["BACKGROUND_CONVERSATION_ACTIONS_RECONCILE_EVENT"] = $b6c892aa1734c634$export$b5bdcb45f62962d2;
module.exports["AGENT_RESOLVE_TIMEOUT_MS"] = $b6c892aa1734c634$export$a31756fd55ed0e4f;
module.exports["isAgentMentionSupportedForContentType"] = $b6c892aa1734c634$export$29ca81875e26608b;
module.exports["AGENT_SESSION_SUBSCRIPTION_FAILED_EVENT"] = $b6c892aa1734c634$export$69d55d1f6faf40c9;

});

parcelRegister("4ywyi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");

const $4bdc3d7fb9b087a5$export$5ebe8e393bb44280 = 30000;
const $4bdc3d7fb9b087a5$var$pending = new Map();
const $4bdc3d7fb9b087a5$var$listeners = new Map();
function $4bdc3d7fb9b087a5$export$264c0ddeb33dfb71(commentId) {
    const session = $4bdc3d7fb9b087a5$var$pending.get(commentId);
    if (!session) return;
    clearTimeout(session.timer);
    $4bdc3d7fb9b087a5$var$pending.delete(commentId);
    $4bdc3d7fb9b087a5$var$listeners.get(commentId)?.forEach((listener)=>listener());
}
function $4bdc3d7fb9b087a5$export$2ac6667fe16054df(commentId, agentIdentity) {
    if (!commentId || $4bdc3d7fb9b087a5$var$pending.has(commentId)) return;
    $4bdc3d7fb9b087a5$var$pending.set(commentId, {
        agentIdentity: agentIdentity,
        timer: setTimeout(()=>$4bdc3d7fb9b087a5$export$264c0ddeb33dfb71(commentId), $4bdc3d7fb9b087a5$export$5ebe8e393bb44280)
    });
    $4bdc3d7fb9b087a5$var$listeners.get(commentId)?.forEach((listener)=>listener());
}
function $4bdc3d7fb9b087a5$export$a75abff18bc94659(commentId) {
    return $4bdc3d7fb9b087a5$var$pending.get(commentId)?.agentIdentity;
}
function $4bdc3d7fb9b087a5$export$199399c8372ab507() {
    $4bdc3d7fb9b087a5$var$pending.forEach(({ timer: timer })=>clearTimeout(timer));
    $4bdc3d7fb9b087a5$var$pending.clear();
    $4bdc3d7fb9b087a5$var$listeners.clear();
}
function $4bdc3d7fb9b087a5$var$subscribeToComment(commentId, listener) {
    if (!commentId) return ()=>{};
    const subscribers = $4bdc3d7fb9b087a5$var$listeners.get(commentId) ?? new Set();
    $4bdc3d7fb9b087a5$var$listeners.set(commentId, subscribers);
    subscribers.add(listener);
    return ()=>{
        subscribers.delete(listener);
        if (subscribers.size === 0) {
            $4bdc3d7fb9b087a5$var$listeners.delete(commentId);
            // StrictMode re-subscribes synchronously during effect replay.
            queueMicrotask(()=>{
                if (!$4bdc3d7fb9b087a5$var$listeners.has(commentId)) $4bdc3d7fb9b087a5$export$264c0ddeb33dfb71(commentId);
            });
        }
    };
}
function $4bdc3d7fb9b087a5$export$d9da892f9e55ea46(commentId, hasSession) {
    const subscribe = (0, $cozmU.useCallback)((listener)=>$4bdc3d7fb9b087a5$var$subscribeToComment(commentId, listener), [
        commentId
    ]);
    const getSnapshot = (0, $cozmU.useCallback)(()=>$4bdc3d7fb9b087a5$var$pending.has(commentId), [
        commentId
    ]);
    const isPending = (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, ()=>false);
    (0, $cozmU.useEffect)(()=>{
        if (commentId && hasSession) $4bdc3d7fb9b087a5$export$264c0ddeb33dfb71(commentId);
    }, [
        commentId,
        hasSession
    ]);
    return !hasSession && isPending;
}
function $4bdc3d7fb9b087a5$export$702d4b653dc0132b(commentIds) {
    // Stable by contents: callers may derive a new ID array from a reply list each render.
    const idsKey = (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) ? JSON.stringify([
        ...new Set(commentIds.filter(Boolean))
    ].sort()) : '[]';
    const ids = (0, $cozmU.useMemo)(()=>JSON.parse(idsKey), [
        idsKey
    ]);
    const subscribe = (0, $cozmU.useCallback)((listener)=>{
        const unsubscribe = ids.map((id)=>$4bdc3d7fb9b087a5$var$subscribeToComment(id, listener));
        return ()=>unsubscribe.forEach((dispose)=>dispose());
    }, [
        ids
    ]);
    const getSnapshot = (0, $cozmU.useCallback)(()=>JSON.stringify(ids.filter((id)=>$4bdc3d7fb9b087a5$var$pending.has(id))), [
        ids
    ]);
    const snapshot = (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, ()=>'[]');
    return (0, $cozmU.useMemo)(()=>new Set(JSON.parse(snapshot)), [
        snapshot
    ]);
}
module.exports["clearOptimisticCommentAgentSession"] = $4bdc3d7fb9b087a5$export$264c0ddeb33dfb71;
module.exports["startOptimisticCommentAgentSession"] = $4bdc3d7fb9b087a5$export$2ac6667fe16054df;
module.exports["getOptimisticCommentAgentIdentity"] = $4bdc3d7fb9b087a5$export$a75abff18bc94659;
module.exports["useOptimisticCommentAgentSession"] = $4bdc3d7fb9b087a5$export$d9da892f9e55ea46;
module.exports["useOptimisticCommentAgentSessions"] = $4bdc3d7fb9b087a5$export$702d4b653dc0132b;

});

parcelRegister("9hI9O", function(module, exports) {

var $feawE = parcelRequire("feawE");


var $95cHD = parcelRequire("95cHD");


var $85mU8 = parcelRequire("85mU8");


var $5Tn11 = parcelRequire("5Tn11");


var $dlR4F = parcelRequire("dlR4F");

async function $531f3455c42a057e$export$971fd65efd490cad({ agentId: agentId, source: source, prompt: prompt, name: name, sourceId: sourceId, tags: tags }) {
    // Desktop owns its own command receiver and does not yet support this extension.
    if ((0, $95cHD.isWebviewContext)()) return false;
    const bridge = (0, $85mU8.getBrowserBridgeAPI)();
    const senderId = (0, $feawE.client)(`confluence-comment-agent-${crypto.randomUUID()}`);
    bridge.ready(senderId);
    try {
        const result = await bridge.send((0, $dlR4F.StartBackgroundAgentConversationCommand), {
            senderId: senderId,
            receiverId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
            agentId: agentId,
            source: source,
            prompt: prompt,
            name: name,
            sourceId: sourceId,
            tags: tags,
            useCurrentPageContext: true
        }).result();
        return result === true;
    } finally{
        // The receiver acknowledges before running the agent; this client owns no stream UI.
        bridge.teardown(senderId);
    }
}
module.exports["sendBackgroundAgentInvocation"] = $531f3455c42a057e$export$971fd65efd490cad;

});

parcelRegister("henaO", function(module, exports) {
// Bound tab-local bookkeeping. Evicted sources may require recovery or approval in Chat.
const $cdcf0281b63a67c2$var$MAX_LOCAL_SOURCES = 20;
// Shared by the save handler and later approval mounts; a hook-local ref would lose that link.
// These IDs correlate requests, not authorize actions. A reload or duplicate module instance can
// lose the association; Chat still validates the session and falls back when it cannot recover.
const $cdcf0281b63a67c2$var$sourceIdsByComment = new Map();
const $cdcf0281b63a67c2$export$9bbb950573b73df9 = (commentId)=>{
    const sourceId = crypto.randomUUID();
    $cdcf0281b63a67c2$var$sourceIdsByComment.delete(commentId);
    $cdcf0281b63a67c2$var$sourceIdsByComment.set(commentId, sourceId);
    if ($cdcf0281b63a67c2$var$sourceIdsByComment.size > $cdcf0281b63a67c2$var$MAX_LOCAL_SOURCES) $cdcf0281b63a67c2$var$sourceIdsByComment.delete($cdcf0281b63a67c2$var$sourceIdsByComment.keys().next().value);
    return sourceId;
};
const $cdcf0281b63a67c2$export$ba82410dfcac81b4 = (commentId)=>$cdcf0281b63a67c2$var$sourceIdsByComment.get(commentId);
const $cdcf0281b63a67c2$export$26f0061ba548c8fc = ()=>$cdcf0281b63a67c2$var$sourceIdsByComment.clear();
module.exports["registerBackgroundConversationSource"] = $cdcf0281b63a67c2$export$9bbb950573b73df9;
module.exports["getBackgroundConversationSource"] = $cdcf0281b63a67c2$export$ba82410dfcac81b4;

});

parcelRegister("gurMq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $emtVP = parcelRequire("emtVP");

function $c813792041e0815a$export$814a52618fb8e5d7({ enabled: enabled = true, cloudId: cloudId } = {}) {
    const [showFyi, setShowFyi] = (0, $cozmU.useState)(false);
    const [agent, setAgent] = (0, $cozmU.useState)();
    // Per-editor cache of mention-id → resolved agent identity (or null when the id
    // is not an agent). Guarantees each distinct id hits the agents endpoint at most
    // once. `inFlight` dedupes concurrent resolutions for the same id.
    const cacheRef = (0, $cozmU.useRef)(new Map());
    const inFlightRef = (0, $cozmU.useRef)(new Set());
    const abortControllersRef = (0, $cozmU.useRef)(new Set());
    // Ids of the latest non-fast-path mention candidates, so async resolutions can
    // re-evaluate visibility against the current doc.
    const latestCandidateIdsRef = (0, $cozmU.useRef)([]);
    const mountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        mountedRef.current = true;
        // Capture the (stable, never-reassigned) ref-held collections so the cleanup
        // operates on the same objects without reading `.current` at teardown
        // (satisfies react-hooks/exhaustive-deps).
        const abortControllers = abortControllersRef.current;
        const inFlight = inFlightRef.current;
        return ()=>{
            mountedRef.current = false;
            abortControllers.forEach((controller)=>controller.abort());
            abortControllers.clear();
            inFlight.clear();
        };
    }, []);
    // Re-derive showFyi/agent from the cache for the current doc's mention ids.
    const applyFromCache = (0, $cozmU.useCallback)(()=>{
        const knownAgent = latestCandidateIdsRef.current.map((id)=>cacheRef.current.get(id)).find((value)=>!!value);
        setShowFyi(!!knownAgent);
        setAgent((prev)=>{
            if (!knownAgent) return undefined;
            return prev?.id === knownAgent.id && prev?.name === knownAgent.name && prev?.agentNamedId === knownAgent.agentNamedId ? prev : knownAgent;
        });
    }, []);
    const onContentChange = (0, $cozmU.useCallback)((adf)=>{
        if (!enabled) return;
        // Fast path — a freshly-typed agent mention still carries userType==='APP'.
        const fastPath = (0, $emtVP.extractAgentMentionFromAdf)(adf);
        if (fastPath) {
            const id = fastPath.agentId;
            latestCandidateIdsRef.current = [];
            setShowFyi(true);
            // Show the name immediately; reuse any avatar key already resolved for this id.
            const cached = cacheRef.current.get(id);
            setAgent((prev)=>{
                const next = {
                    id: id,
                    name: fastPath.agentName,
                    agentNamedId: cached?.agentNamedId
                };
                return prev?.id === next.id && prev?.name === next.name && prev?.agentNamedId === next.agentNamedId ? prev : next;
            });
            // The fast path is otherwise network-free, so an OOTB agent (e.g. Canva) would render the
            // generic fallback avatar. Resolve once (cached) to enrich with the real avatar key. We
            // already KNOW this is an agent (userType==='APP'), so a failed/empty resolve keeps the
            // baseline rather than hiding the nudge.
            if (cloudId && !cacheRef.current.has(id) && !inFlightRef.current.has(id)) {
                inFlightRef.current.add(id);
                const controller = new AbortController();
                abortControllersRef.current.add(controller);
                (0, $emtVP.resolveAgentFromMentionId)(id, cloudId, controller.signal).then((resolved)=>{
                    abortControllersRef.current.delete(controller);
                    inFlightRef.current.delete(id);
                    if (!mountedRef.current) return;
                    // Cache the result — even null — so a failed/non-agent resolution isn't
                    // retried on every subsequent keystroke (the `.has(id)` guard short-circuits).
                    cacheRef.current.set(id, resolved);
                    if (!resolved) return;
                    setAgent((prev)=>prev?.id === id ? {
                            ...prev,
                            agentNamedId: resolved.agentNamedId
                        } : prev);
                }).catch(()=>{
                    abortControllersRef.current.delete(controller);
                    inFlightRef.current.delete(id);
                });
            }
            return;
        }
        // Fallback — userType may have been stripped (paste / reloaded comment).
        // Only mentions that have LOST their userType need id-resolution; live
        // mentions carry a userType (APP is handled by the fast path above, any
        // other type is not an agent), so they are skipped to avoid wasted calls.
        const candidateIds = (0, $emtVP.extractUnresolvedMentionIds)(adf);
        latestCandidateIdsRef.current = candidateIds;
        // Reflect anything already cached immediately (no flicker, no refetch).
        applyFromCache();
        // The async fallback needs a cloudId to call the agents endpoint.
        if (!cloudId) return;
        for (const id of candidateIds){
            if (cacheRef.current.has(id) || inFlightRef.current.has(id)) continue; // already resolved, or a resolution is already in flight
            inFlightRef.current.add(id);
            const controller = new AbortController();
            abortControllersRef.current.add(controller);
            (0, $emtVP.resolveAgentFromMentionId)(id, cloudId, controller.signal).then((resolved)=>{
                abortControllersRef.current.delete(controller);
                inFlightRef.current.delete(id);
                if (!mountedRef.current) return;
                cacheRef.current.set(id, resolved);
                applyFromCache();
            }).catch(()=>{
                // resolveAgentFromMentionId is not expected to reject (it catches
                // internally), but guard defensively so a future refactor — or a
                // throw from applyFromCache — can't surface an unhandled rejection
                // or leave the id stuck in-flight. The nudge is best-effort.
                abortControllersRef.current.delete(controller);
                inFlightRef.current.delete(id);
            });
        }
    }, [
        enabled,
        cloudId,
        applyFromCache
    ]);
    return (0, $cozmU.useMemo)(()=>({
            showFyi: showFyi,
            agent: agent,
            onContentChange: onContentChange
        }), [
        showFyi,
        agent,
        onContentChange
    ]);
}
module.exports["useAgentMentionFyiNudge"] = $c813792041e0815a$export$814a52618fb8e5d7;

});

parcelRegister("4rKYp", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $016f78fedc012cce$export$c82fcdcb4a4bd17 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YwMBi",
    name: "AgentMentionFyiNudgeAsync",
    loader: async ()=>(await (parcelRequire("3mLV0"))).AgentMentionFyiNudge
});
module.exports["AgentMentionFyiNudgeAsync"] = $016f78fedc012cce$export$c82fcdcb4a4bd17;

});

parcelRegister("3mLV0", function(module, exports) {

let $273898c62ad6016a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $273898c62ad6016a$var$load("7EorR"),
    $273898c62ad6016a$var$load("jqoep"),
    $273898c62ad6016a$var$load("l64sb")
]).then(()=>parcelRequire('kz0zp'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("lFkRf", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $CP0sd = parcelRequire("CP0sd");


var $FBfum = parcelRequire("FBfum");

const $ad3c53086a228972$var$parseError = (error)=>{
    const { message: message } = error;
    let errorMessage;
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from queries/mutations always have the same format:
   * GraphQL error: <GUID>:[ <EXCEPTION>:] <REASON>
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
    } else errorMessage = message;
    const parsedError = {
        message: errorMessage
    };
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
    return parsedError;
};
const $ad3c53086a228972$export$a67f8c1198066537 = (error)=>{
    if ((0, $6fil2.containsNetworkError)(error)) return (0, $FBfum.i18n).networkError;
    const parsedError = $ad3c53086a228972$var$parseError(error);
    const { message: message } = parsedError;
    switch(true){
        case message === (0, $CP0sd.ObjectCommentsError).VIEW_NOT_PERMITTED:
            return (0, $FBfum.i18n).viewNotPermitted;
        case message === (0, $CP0sd.ObjectCommentsError).NO_CREATE_PERMS:
            return (0, $FBfum.i18n).createNotPermitted;
        case $ad3c53086a228972$export$ecdfad00dc25b27e(message):
            return (0, $FBfum.i18n).contentNotFound;
        default:
            return (0, $FBfum.i18n).unexpectedError;
    }
};
const $ad3c53086a228972$export$c4a6c57f5b95da54 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).viewNotPermitted.id;
const $ad3c53086a228972$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).networkError.id;
const $ad3c53086a228972$export$aa951ce6b8761d86 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).createNotPermitted.id;
const $ad3c53086a228972$export$c572523773a0cf86 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).contentNotFound.id;
const $ad3c53086a228972$export$d1e82e172a94f308 = (translatedMessage)=>$ad3c53086a228972$export$aa951ce6b8761d86(translatedMessage) || $ad3c53086a228972$export$c4a6c57f5b95da54(translatedMessage) || $ad3c53086a228972$export$c572523773a0cf86(translatedMessage);
const $ad3c53086a228972$var$CONTENT_NOT_FOUND_PATTERNS = [
    /Content with id \S+ for comment container is not found/,
    /No content found with id\s*:\s*\S+/,
    /Cannot create a \[[^\]]+\] comment on content with \[(?:trashed|deleted|archived)\] status/
];
const $ad3c53086a228972$export$ecdfad00dc25b27e = (errorMessage)=>$ad3c53086a228972$var$CONTENT_NOT_FOUND_PATTERNS.some((pattern)=>pattern.test(errorMessage));
module.exports["getTranslatedError"] = $ad3c53086a228972$export$a67f8c1198066537;
module.exports["isRawContentNotFoundError"] = $ad3c53086a228972$export$ecdfad00dc25b27e;
module.exports["isViewNotPermittedError"] = $ad3c53086a228972$export$c4a6c57f5b95da54;
module.exports["isNetworkError"] = $ad3c53086a228972$export$476aa014e2fd89d5;
module.exports["isCommentAbortableError"] = $ad3c53086a228972$export$d1e82e172a94f308;

});

parcelRegister("CP0sd", function(module, exports) {
var $a1a7014f0329fe2c$export$37d35ac9f5bc0a58 = /*#__PURE__*/ function(ObjectCommentsError) {
    // view
    ObjectCommentsError["VIEW_NOT_PERMITTED"] = "403 Forbidden, current user not permitted to use Confluence.";
    // Create
    ObjectCommentsError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    ObjectCommentsError["CONTAINER_NOT_FOUND"] = "Content with id %d for comment container is not found. Please provide correct container id.";
    return ObjectCommentsError;
}({});
module.exports["ObjectCommentsError"] = $a1a7014f0329fe2c$export$37d35ac9f5bc0a58;

});

parcelRegister("FBfum", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $93264f9de833f05e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    unableToLoadCommentsTitle: {
        id: "comments-util.error.unable.to.load.comments",
        defaultMessage: "Unable to load comments"
    },
    networkError: {
        id: "comments-util.error.network",
        defaultMessage: "A network error was encountered when loading comments. Please try refreshing the page."
    },
    viewNotPermitted: {
        id: "comments-util.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view comments on this page. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "comments-util.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    contentNotFound: {
        id: "comments-util.error.content.not.found",
        defaultMessage: "The page you are trying to comment on is no longer available. It may have been deleted or archived."
    },
    unexpectedError: {
        id: "comments-util.error.unexpected",
        defaultMessage: "Something went wrong when loading comments on this page."
    }
});
module.exports["i18n"] = $93264f9de833f05e$export$a7357cdd1f0b0168;

});


//# sourceMappingURL=CommentsPanelFooter.92e275bb.js.map
